import { AxiosResponse } from 'axios';
import { ApiService } from './api.service';
import { URLS } from './endpoints';

export const fetchSpeakers = async (roleId: any, inputValue = '', page = 1) => {
    try {
        const response: AxiosResponse = await ApiService.getData(
            `${URLS.GET_VIDEO_SPEAKERS.url}?PageNumber=${page}&PageSize=20&SearchText=${inputValue}&SortFieldName=firstName&RoleId=${roleId}`
        );

        const items = Array.isArray(response.data.result) ? response.data.result : [];

        return {
            options: items.map((user: any) => ({
                value: user.id,
                label: `${user.firstName} ${user.lastName}`.trim()
            })),
            hasMore: response.data.totalCount > page * 20
        };
    } catch (err) {
        console.error('Failed to load speakers:', err);
        return { options: [], hasMore: false };
    }
};


export const fetchVideos = async (
    channelId: string,
    inputValue: string,
    page: number
): Promise<{ options: { value: string; label: string }[]; hasMore: boolean }> => {
    if (!channelId) return { options: [], hasMore: false };

    const token = localStorage.getItem('token');

    const payload: any = {
        channelId,
        pageNumber: page,
        pageSize: 50
    };
    if (inputValue) payload.criteria = inputValue;

    const result: any = await ApiService.postData(
        `${URLS.SEARCH_VIDEO.url}`, payload
    );

    const data = result.data;

    const options = (data.result || []).map((item: any) => ({
        value: item.id,
        label: item.title
    }));

    const totalLoaded = (page - 1) * 50 + options.length;
    const hasMore = totalLoaded < (data.totalCount || 0);

    return { options, hasMore };
};


export const fetchMemberLists = async (
    inputValue = '',
    page = 1
): Promise<{ options: { value: string; label: string }[]; hasMore: boolean }> => {
    try {
        const response: AxiosResponse = await ApiService.getData(
            `${URLS.GET_MEMBER_LIST.url}?filter=${inputValue}&pageNo=${page}&pageSize=20`
        );
        const items = Array.isArray(response.data.result) ? response.data.result : [];
        return {
            options: items.map((item: any) => ({
                value: item.id,
                label: item.name
            })),
            hasMore: response.data.totalCount > page * 20
        };
    } catch (err) {
        console.error('Failed to load member lists:', err);
        return { options: [], hasMore: false };
    }
};